import request from './api';
import { API_SEARCH } from '../constants/api';

const normalizeSearch = response => ({
  ...response,
  total: response.globalNumberResult,
  totalAll: response.globalNumberResult,
  totalContents: response.numberOfContents,
  totalDocuments: response.numberOfDocuments,
  totalFolders: response.numberOfFolders,
  totalUsers: response.numberOfUsers,
  totalAssociations: response.numberOfAssociations
});

export const getSearch = params =>
  request(`${API_SEARCH}search`, { method: 'GET', params }).then(
    normalizeSearch
  );

export const getSearchByType = (type, params) => {
  let urlParam;

  if (type === 'all') {
    urlParam = '';
  } else {
    urlParam = type;
  }

  return request(`${API_SEARCH}search/${urlParam}`, {
    method: 'GET',
    params: {
      ...params,
      page: params.page - 1
    }
  }).then(normalizeSearch);
};
